import { connect } from "react-redux";

import { googleAuthReset } from "../../SocialAuth/socialAuthActions";
import SignUp from "./SignUp";
import {
  resetSignUp,
  resetSignUpError,
  signUp as signUpRequest,
} from "./signUpActions";

const mapStateToProps = state => ({
  signup: state.signUp,
  socialAuth: state.socialAuth,
});

const mapDispatchToProps = {
  signUpRequest,
  resetSignUp,
  resetSignUpError,
  googleAuthReset,
};

export default connect(mapStateToProps, mapDispatchToProps)(SignUp);
